import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import RestService from 'utils/RestService';
import { TABS } from 'features/Big9Tips/utils';

const useTipsData = () => {
    const [tag, setTag] = useState(TABS.alle.tag);

    const fetchBig9Articles = async () => {
        const res = await RestService.GetBig9Articles(tag);
        return res?.data || [];
    };

    const { status, data, error, refetch } = useQuery(
        ['big9Tips' + tag],
        fetchBig9Articles,
        {
            keepPreviousData: true,
            staleTime: 60 * 1000,
        }
    );

    return {
        tipsData: data,
        status,
        error,
        refetch,
        setTag,
    };
};

export default useTipsData;
